import { OfficesFilter } from '../models';
import { useGetOfficesQuery } from '../services/offices.service';

interface UseOfficesProps {
  filters?: OfficesFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useOffices = ({ filters, paginated }: UseOfficesProps) => {
  const {
    data: offices,
    isLoading: isOfficesLoading,
    error,
  } = useGetOfficesQuery({ filters, paginated });

  return {
    offices: offices?.items || [],
    totalItems: offices?.count || [].length,
    totalPages: offices?.count
      ? Math.ceil(offices.count / paginated.pageSize)
      : 0,
    isOfficesLoading,
    error,
  };
};

export default useOffices;
